/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiCampaignTypeFromJSON, ApiCampaignTypeToJSON, } from './ApiCampaignType';
export function ApiCreateUpdateCampaignPayloadFromJSON(json) {
    return ApiCreateUpdateCampaignPayloadFromJSONTyped(json, false);
}
export function ApiCreateUpdateCampaignPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'audienceIds': !exists(json, 'audienceIds') ? undefined : json['audienceIds'],
        'classificationItemIds': !exists(json, 'classificationItemIds') ? undefined : json['classificationItemIds'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'endDate': !exists(json, 'endDate') ? undefined : (new Date(json['endDate'])),
        'fallbackUrl': !exists(json, 'fallbackUrl') ? undefined : json['fallbackUrl'],
        'maxNumberOfLeads': !exists(json, 'maxNumberOfLeads') ? undefined : json['maxNumberOfLeads'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'noCache': !exists(json, 'noCache') ? undefined : json['noCache'],
        'probability': !exists(json, 'probability') ? undefined : json['probability'],
        'startDate': !exists(json, 'startDate') ? undefined : (new Date(json['startDate'])),
        'subdomainId': !exists(json, 'subdomainId') ? undefined : json['subdomainId'],
        'type': !exists(json, 'type') ? undefined : ApiCampaignTypeFromJSON(json['type']),
        'urls': !exists(json, 'urls') ? undefined : json['urls'],
    };
}
export function ApiCreateUpdateCampaignPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'audienceIds': value.audienceIds,
        'classificationItemIds': value.classificationItemIds,
        'description': value.description,
        'endDate': value.endDate === undefined ? undefined : (value.endDate.toISOString()),
        'fallbackUrl': value.fallbackUrl,
        'maxNumberOfLeads': value.maxNumberOfLeads,
        'name': value.name,
        'noCache': value.noCache,
        'probability': value.probability,
        'startDate': value.startDate === undefined ? undefined : (value.startDate.toISOString()),
        'subdomainId': value.subdomainId,
        'type': ApiCampaignTypeToJSON(value.type),
        'urls': value.urls,
    };
}
